import React, { useContext } from "react";
import { LegacyCard as Card, Collapsible, Text, Layout, BlockStack } from "@shopify/polaris";
import { DropZone } from "lib/components";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const Favicon = () => {
  const { FAVICON, FAVICON_SIZE } = constant;
  const {
    faviconImage,
    handleChange,
    // learnMore
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { brand } = currentUser || {};
  const { favicon, updatedAt: brandUpdatedAt = "" } = brand || {};
  const { updatedAt = "" } = favicon || {};
  return (
    <Collapsible open>
      <Layout.AnnotatedSection title={cms("section.favicon.title")} description={cms("section.favicon.description")}>
        <Card
          title={[
            cms("section.favicon.card.title"),
            updatedAt ? (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ) : (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(brandUpdatedAt)}`}</Text>
              </Text>
            ),
          ]}
        >
          <Card.Section>
            <BlockStack gap="10">
              {cms("section.favicon.card.description")}
              <small>{`(${cms("section.favicon.card.size", { item: FAVICON_SIZE })})`}</small>
            </BlockStack>
            <br />
            <DropZone
              id="dropZone"
              onAdd={(value) => handleChange(FAVICON, (value && value.length && value[0]) || "", FAVICON)}
              onRemove={() => handleChange(FAVICON, "", FAVICON)}
              fileList={(faviconImage !== "" && [faviconImage]) || []}
              allowMultiple={false}
            />
            <br />
            <Text variant="bodySm" as="p">
              {cms("section.favicon.caption")}
            </Text>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(Favicon), {
  feature: constant.STANDARD_BRANDING,
});
